import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-income-blue',
  templateUrl: './icon-income-blue.component.html',
  styles: []
})
export class IconIncomeBlueComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
